import React, { useState } from "react";
import "../assets/css/Calender.css";

const Calendar = ({ onDateSelect }) => {
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(today);

  const getDaysInMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();

  const generateCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = getDaysInMonth(year, month);

    const days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(i);
    }
    return days;
  };

  const handlePrevMonth = () => {
    const prev = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
    setCurrentDate(new Date(prev));
  };

  const handleNextMonth = () => {
    const next = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    setCurrentDate(new Date(next));
  };

  const days = generateCalendar();
  const monthYear = currentDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  const handleDateClick = (day) => {
    if (!day) return;
    const selected = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      day
    );
    setSelectedDate(selected);
    setCurrentDate(selected);
    onDateSelect?.(selected);
  };

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button onClick={handlePrevMonth}>❮</button>
        <span>{monthYear}</span>
        <button onClick={handleNextMonth}>❯</button>
      </div>
      <div className="calendar-grid">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
          <div key={d} className="calendar-day-label">
            {d}
          </div>
        ))}
        {days.map((day, index) => {
          const isSelected =
            selectedDate &&
            day === selectedDate.getDate() &&
            currentDate.getMonth() === selectedDate.getMonth() &&
            currentDate.getFullYear() === selectedDate.getFullYear();

          return (
            <div
              key={index}
              className={`calendar-day ${day ? "" : "empty"} ${isSelected ? "selected" : ""}`}
              onClick={() => handleDateClick(day)}
            >
              {day}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;
